<template>
    <div>车辆轨迹实时监控</div>
</template>

<script>
    export default {
        name: "CarTrajectory"
    }
</script>

<style scoped>

</style>
